// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconBrandReddit } from '@tabler/icons';

// constant
const icons = {
    IconBrandReddit
};

const reddit = {
    id: 'reddit',
    type: 'group',
    children: [
        {
            id: 'reddit-dashboard',
            title: <FormattedMessage id="reddit" />,
            type: 'item',
            icon: icons.IconBrandReddit,
            url: '/reddit'
        }
    ]
};

export default reddit;
